<div class="edit-zone-container">
    <jjames-card title="Edit Parking Zone">
        <!-- Loading State -->
        @if (isLoading) {
        <div class="loading-container">
            <p>Loading zone details...</p>
        </div>
        }

        <!-- Form Content -->
        @if (!isLoading) {
        <div class="form-container">
            <!-- Success Alert -->
            @if (successMessage) {
            <jjames-alert type="success" [dismissible]="true" class="alert-spacing">
                {{ successMessage }}
            </jjames-alert>
            }

            <!-- Error Alert -->
            @if (errorMessage) {
            <jjames-alert type="error" [dismissible]="true" class="alert-spacing">
                {{ errorMessage }}
            </jjames-alert>
            }

            <form [formGroup]="editZoneForm" (ngSubmit)="onSubmit()" class="edit-zone-form">
                <!-- Zone Name -->
                <div class="form-field">
                    <jjames-input formControlName="name" label="Zone Name" placeholder="Enter zone name"
                        [required]="true" [variant]="isFieldInvalid('name') ? 'error' : 'default'">
                    </jjames-input>
                    @if (isFieldInvalid('name')) {
                    <p class="error-message">{{ getFieldError('name') }}</p>
                    }
                </div>

                <!-- Description -->
                <div class="form-field">
                    <jjames-input formControlName="description" label="Description"
                        placeholder="Enter zone description (optional)"
                        [variant]="isFieldInvalid('description') ? 'error' : 'default'">
                    </jjames-input>
                    @if (isFieldInvalid('description')) {
                    <p class="error-message">{{ getFieldError('description') }}</p>
                    }
                </div>

                <!-- Capacity -->
                <div class="form-field">
                    <jjames-input formControlName="capacity" label="Capacity" placeholder="Enter zone capacity"
                        type="number" [required]="true" [variant]="isFieldInvalid('capacity') ? 'error' : 'default'">
                    </jjames-input>
                    @if (isFieldInvalid('capacity')) {
                    <p class="error-message">{{ getFieldError('capacity') }}</p>
                    }
                </div>

                <!-- Governance Type -->
                <div class="form-field">
                    <label class="form-label">Governance Type</label>
                    <select formControlName="governanceType" class="form-select">
                        @for (type of governanceTypes; track type) {
                        <option [value]="type">
                            {{ type }}
                        </option>
                        }
                    </select>
                    @if (isFieldInvalid('governanceType')) {
                    <p class="error-message">{{ getFieldError('governanceType') }}</p>
                    }
                </div>

                <!-- Address -->
                <div class="form-field">
                    <jjames-input formControlName="address" label="Address" placeholder="Enter zone address (optional)"
                        [variant]="isFieldInvalid('address') ? 'error' : 'default'">
                    </jjames-input>
                    @if (isFieldInvalid('address')) {
                    <p class="error-message">{{ getFieldError('address') }}</p>
                    }
                </div>

                <!-- Action Buttons -->
                <div class="form-actions">
                    <jjames-button type="button" variant="secondary" (click)="onCancel()" [disabled]="isSubmitting">
                        Cancel
                    </jjames-button>

                    <jjames-button type="submit" variant="primary" [disabled]="!editZoneForm.valid || isSubmitting">
                        {{ isSubmitting ? 'Updating...' : 'Update Zone' }}
                    </jjames-button>
                </div>
            </form>
        </div>
        }
    </jjames-card>
</div>